import { FORECAST_ADVISORY_MODES } from '../config/forecastAdvisories.config';
import { isValidMapPosition } from 'utils/maps/coordinate.utils';

/**
 * Returns the advisories shown by the selected Storm Center mode.
 * The local mode keeps only alerts that have a usable map location and fall within the limit.
 */
export const getVisibleForecastAdvisories = (
  alerts,
  { mode = FORECAST_ADVISORY_MODES.all, maximumDistanceMiles } = {},
) => {
  const availableAlerts = Array.isArray(alerts) ? alerts : [];
  if (mode !== FORECAST_ADVISORY_MODES.local) return availableAlerts;

  const distanceLimit = Number(maximumDistanceMiles);
  if (!Number.isFinite(distanceLimit)) return [];

  return availableAlerts.filter((alert) => {
    const distanceToUser = Number(alert?.distanceToUser);

    return (
      isValidMapPosition(alert?.processedCenter) &&
      alert?.distanceToUser !== null &&
      alert?.distanceToUser !== undefined &&
      alert?.distanceToUser !== '' &&
      Number.isFinite(distanceToUser) &&
      distanceToUser <= distanceLimit
    );
  });
};
